import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { NavigationBarPresentation } from '../NavigationBar/NavigationBarPresentation.js';
import { hostClass } from './FooterMetabar.styles.js';

var defaultProps = {};
var FooterMetabarPresentation = fComp(function (props) {
  var _cleanupClassObject;
  var _a;
  var id = props.id,
    className = props.className,
    isStencilHost = props.isStencilHost,
    navigationTree = props.navigationTree,
    navigationActionAs = props.navigationActionAs,
    socialLinks = props.socialLinks;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, navigationTree && /*#__PURE__*/React.createElement(NavigationBarPresentation, {
    size: "meta-bar",
    value: "",
    navigationTree: navigationTree,
    navigationActionAs: navigationActionAs,
    centeredLayout: true
  }), ((_a = socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.props) === null || _a === void 0 ? void 0 : _a.children) && /*#__PURE__*/React.createElement("ul", {
    className: "".concat(lsgPre, "footer-metabar-sociallinks")
  }, socialLinks.props.children.map(function (child, i) {
    return (
      /*#__PURE__*/
      // tslint:disable-next-line:jsx-key
      React.createElement("li", {
        key: i,
        className: "".concat(lsgPre, "footer-metabar-sociallink")
      }, child)
    );
  })));
}, defaultProps);
FooterMetabarPresentation.displayName = "FooterMetabarPresentation";

export { FooterMetabarPresentation, defaultProps };
